export const getCookie = (cookieName) => document.cookie.split('; ').find((row) => row.startsWith(cookieName));
